import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';

import { SearchSuggestion } from './searchSuggestions.types';

type GetSearchSuggestionsParams = {
    deployment: string;
    ipAddress: string;
    term: string;
    useScoutCategories?: boolean;
};

type GetSearchSuggestionsResponse = {
    payload?: SearchSuggestion[];
};

/**
 * GETs search suggestions from the search-party `/search/suggestions` endpoint.
 * @see https://search-party-DEPLOYMENT.liveauctioneers.com/search/suggestions?{queryParams}
 * @see https://github.com/LIVEauctioneers/search-party/tree/master/functions/SearchSuggestionsV2
 */
export const getSearchSuggestions = ({
    deployment,
    ipAddress,
    term,
    useScoutCategories,
}: GetSearchSuggestionsParams): Promise<GetSearchSuggestionsResponse> =>
    new Promise((resolve, reject) => {
        const request = makeGet({
            apiPath: 'suggestions',
            deployment,
            ipAddress,
            path: ApiHosts.Search,
            queryParams: {
                auctionHouseQueryCount: 3,
                itemQueryCount: 6,
                term,
                ...(useScoutCategories && { useScoutCategories: true }),
            },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
